import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { ExportXlsxComponent } from 'src/app/components/export-xlsx/export-xlsx.component';
import { applyMixins } from 'src/app/components/mixin/mixin';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { ItemService } from 'src/app/pages/inventory/stock-items/item.service';
import { ASSETSROOT } from 'src/app/services/api/api-endpoints';
import { ApiConnectionService } from 'src/app/services/api/apiconnection.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { JobReportsService } from '../job-reports.service';


class BaseClass { }
interface BaseClass extends ModalComponent, ExportXlsxComponent { }
applyMixins(BaseClass, [ModalComponent, ExportXlsxComponent]);

@Component({
  selector: 'app-completed',
  templateUrl: './completed.component.html',
  styleUrls: ['./completed.component.scss']
})
export class CompletedComponent extends BaseClass implements OnInit {

  currentFilter: any = {};
  reportForm = new FormGroup({
    dateRange: new FormControl([this.settingService.getCurrentMonthDates().first,
      this.settingService.getCurrentMonthDates().last])
  });

  exporting = false;
  showFilter = false;
  assetsRoot = ASSETSROOT;
  loading = false;
  pdfReport: any;

  constructor(
    private jobReportsService: JobReportsService,
    public modalService: BsModalService,
    public apiConnect: ApiConnectionService,
    public authService: AuthenticationService,
    private settingService: SettingsService
  ) {
    super();
  }

  ngOnInit(): void {

    this.reportForm.valueChanges.subscribe(val => {
      const currentFilter: any = {};
      currentFilter.startDate = this.filterdateRange.value[0];
      currentFilter.endDate = this.filterdateRange.value[1];

      this.currentFilter = currentFilter;
    });
    // this.getReports();
  }

  getReports(): void {
    this.loading = true;
    this.jobReportsService.getJobReports('CompletedJobs', undefined, (res, status) => {
      this.loading = false;
      if (status) {
        this.pdfReport = res.data;
        console.log(res);
      }
    },this.currentFilter);
  }

  getReportsXls(): void {
    this.loading = true;
    this.jobReportsService.getJobReports('CompletedJobsXls', undefined, (res, status) => {
      this.loading = false;
      if (status) {
        this.exportExcelReport(res.data);
      }
    }, this.currentFilter);
  }

  exportExcelReport(pdfReport: any): void {
    this.exporting = true;
    if (pdfReport) {
      const blobFile = this.convertBase64xlsxToBlob(pdfReport.data);
      this.exportXlsx(blobFile, 'CompletedJobs.xlsx');
    }
    this.exporting = false;
  }

  // Form Controls
  get filterdateRange(): FormControl {
    return this.reportForm.get('dateRange') as FormControl;
  }
}
